import Tamantekno1 from '../../../Media/Ruko BSD/Taman Tekno/Taman Tekno (1).webp'
import Tamantekno2 from '../../../Media/Ruko BSD/Taman Tekno/Taman Tekno (2).webp'

const Tamanteknoimages =[
Tamantekno1,Tamantekno2
]

export default Tamanteknoimages;
